// extracted by mini-css-extract-plugin
export default {"col_box":"index_col_box_E1dHM","col_navlist":"index_col_navlist_JHl37","pa":"index_pa_AW6w9"};